var _path, _path2, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36957 5.82715H45.1522C46.761 5.82715 48.0652 7.13136 48.0652 8.74019V14.5663H4.36957C1.95633 14.5663 0 12.61 0 10.1967C0 7.78346 1.95631 5.82715 4.36957 5.82715Z",
    fill: "url(#paint0_linear_1429_5137)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8888 4.37012H7.2832V57.7757H53.8888V4.37012Z",
    fill: "url(#paint1_linear_1429_5137)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1429_5137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4334 0H8.73777C7.93336 0 7.28125 0.652114 7.28125 1.45652V57.7754H53.8899V1.45652C53.8899 0.652114 53.2378 0 52.4334 0Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4334 0H8.73777C7.93336 0 7.28125 0.652114 7.28125 1.45652V57.7754H53.8899V1.45652C53.8899 0.652114 53.2378 0 52.4334 0Z",
    fill: "url(#paint2_linear_1429_5137)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73777 0.6H52.4334C52.9065 0.6 53.2899 0.983486 53.2899 1.45652V57.1754H7.88125V1.45652C7.88125 0.983485 8.26473 0.6 8.73777 0.6Z",
    stroke: "url(#paint3_linear_1429_5137)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_1429_5137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.1963V56.8049C0 62.4358 4.56476 67.0005 10.1957 67.0005H58.2609C59.8697 67.0005 61.1739 65.6963 61.1739 64.0875V17.4787C61.1739 15.8699 59.8697 14.5658 58.2609 14.5658H4.36956C1.95633 14.5658 0 12.6095 0 10.1963Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.1963V56.8049C0 62.4358 4.56476 67.0005 10.1957 67.0005H58.2609C59.8697 67.0005 61.1739 65.6963 61.1739 64.0875V17.4787C61.1739 15.8699 59.8697 14.5658 58.2609 14.5658H4.36956C1.95633 14.5658 0 12.6095 0 10.1963Z",
    fill: "url(#paint4_linear_1429_5137)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6 56.8049V13.4347C1.51139 14.4946 2.8621 15.1658 4.36956 15.1658H58.2609C59.5383 15.1658 60.5739 16.2013 60.5739 17.4787V64.0875C60.5739 65.365 59.5383 66.4005 58.2609 66.4005H10.1957C4.89613 66.4005 0.6 62.1044 0.6 56.8049Z",
    stroke: "url(#paint5_linear_1429_5137)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1429_5137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5431 33.5H50.9779C46.9625 33.5 43.6953 36.7672 43.6953 40.7826C43.6953 44.798 46.9625 48.0652 50.9779 48.0652H65.5431C66.3475 48.0652 66.9997 47.4131 66.9997 46.6087V34.9565C66.9997 34.1522 66.3475 33.5 65.5431 33.5Z",
    fill: "url(#paint6_linear_1429_5137)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1429_5137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9775 43.6962C52.5863 43.6962 53.8905 42.392 53.8905 40.7832C53.8905 39.1743 52.5863 37.8701 50.9775 37.8701C49.3687 37.8701 48.0645 39.1743 48.0645 40.7832C48.0645 42.392 49.3687 43.6962 50.9775 43.6962Z",
    fill: "white",
    fillOpacity: 0.16
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1429_5137",
    x: -16.7188,
    y: -24,
    width: 94.6084,
    height: 105.775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5137",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_1429_5137",
    x: -24,
    y: -13.8037,
    width: 109.174,
    height: 104.805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5137",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1429_5137",
    x: 43.6953,
    y: 33.5,
    width: 23.3047,
    height: 22.5654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1429_5137",
    x: 48.0645,
    y: 37.8701,
    width: 5.82617,
    height: 13.8262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_5137",
    x1: 2.00272,
    y1: 7.57498,
    x2: 35.7286,
    y2: 33.3378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_5137",
    x1: 9.2251,
    y1: 15.0512,
    x2: 60.2594,
    y2: 21.2368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_5137",
    x1: 9.22328,
    y1: 11.5551,
    x2: 60.3686,
    y2: 17.2857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1429_5137",
    x1: 8.73777,
    y1: 2.62615,
    x2: 53.8899,
    y2: 2.62615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1429_5137",
    x1: 2.54891,
    y1: 21.5571,
    x2: 69.0325,
    y2: 31.5013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1429_5137",
    x1: 1.91168,
    y1: 12.7783,
    x2: 61.1739,
    y2: 12.7783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1429_5137",
    x1: 44.6663,
    y1: 36.413,
    x2: 69.3415,
    y2: 41.8964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoWallet);
export default __webpack_public_path__ + "static/media/video-wallet.feb6466dc09f9db15d598027b3fb1fe9.svg";
export { ForwardRef as ReactComponent };